
var swiper = new Swiper(".habitSwiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
});

new Swiper(".productSwiper", {
    slidesPerView: 1,
    spaceBetween: 15,
    loop: true,

    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },

    breakpoints: {
        768: {
            slidesPerView: 3,
        },
        992: {
            slidesPerView: 5,
            allowTouchMove: false,
        }
    },

    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
});

document.addEventListener("DOMContentLoaded", () => {

  if (window.innerWidth > 749) return;

  const stickyBar = document.querySelector(".sticky-product-bar");
  const originalBtn = document.querySelector(".product-form__submit");

  if (!stickyBar || !originalBtn) return;

  window.addEventListener("scroll", () => {

    const rect = originalBtn.getBoundingClientRect();

    if (rect.bottom < 0) {
      stickyBar.classList.add("show");
    } else {
      stickyBar.classList.remove("show");
    }

  });

  // Add To Cart
  document
    .querySelector(".sticky-atc-btn")
    ?.addEventListener("click", () => {
      originalBtn.click();
    });

  // Buy Now
  document
    .querySelector(".sticky-buy-now-btn")
    ?.addEventListener("click", () => {

      const buyNowBtn =
        document.querySelector(".shopify-payment-button__button");

      if (buyNowBtn) {
        buyNowBtn.click();
      }

    });


  const menuDrawer = document.getElementById("Details-menu-drawer-container");

  if (!menuDrawer) return;

  menuDrawer.addEventListener("toggle", function () {
    if (this.open) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  });


});